module.exports = __webpack_public_path__ + "img/diapositiva-2-2.36f4ab51.png";